
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...all]",
      function () {
        return require("private-next-pages/[...all].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...all]"])
      });
    }
  